module.exports = __webpack_public_path__ + "media/dashboard/assets/images/agent-b168f3f941e4e10dbd9179b8cb55047b.svg";